/** Typed wrapper over fetch for /api/auth/*. */

import { getJson } from "@/lib/http";
import type { AuthStatus, LoginRequest } from "@/types/auth";

const BASE = "/api/auth";

export const authApi = {
  /** Returns {user} — null when not logged in. Never throws on 401 (it's
   * deliberately a 200 response so the frontend can call it on app load). */
  me(): Promise<AuthStatus> {
    return getJson<AuthStatus>(`${BASE}/me`);
  },
  login(payload: LoginRequest): Promise<AuthStatus> {
    return getJson<AuthStatus>(`${BASE}/login`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  logout(): Promise<AuthStatus> {
    return getJson<AuthStatus>(`${BASE}/logout`, { method: "POST" });
  },
};
